<head>
    <title>PDF Viewer</title>
    <link rel="icon" type="image/png" href="assets/favicon.ico">
</head>

<!-- Embed the PDF -->
<iframe [src]="pdfUrl" width="100%" height="100%" style="border: none;"></iframe>
